import React, { cloneElement, useMemo } from "react";

const Tag = "span";

const TruncatedElement = ({
    children,
    lines,
    getRef,
    lineHeight = "1.6rem",
}: any) => {
    const getStyles = useMemo(() => {
        return {
            overflow: "hidden",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: parseInt(lines),
            // -0.2rem => magic number to avoid showing part of the next line
            maxHeight: `calc(${parseInt(lines)} * ${lineHeight} - 0.2rem)`,
            lineHeight: lineHeight,
            textOverflow: "ellipsis",
        };
    }, [lines]);

    const getChildrenElement = () => {
        if (children.type) return children;

        return <Tag>{children}</Tag>;
    };

    const getClonedChildren = () => {
        const childrenElement = getChildrenElement();

        const clonedElement = cloneElement(childrenElement, {
            style: { ...childrenElement.props.style, ...getStyles },
            ref: getRef,
        });

        return clonedElement;
    };

    return getClonedChildren();
};

export default TruncatedElement;
